import React from 'react';
import I18n from 'i18n-js';
import gql from 'graphql-tag';
import { graphql, ChildMutateProps } from 'react-apollo';
import { RemoveFeedEntry, reverb_feed_FeedEntry } from '../schemas/rql';
import { RCCloseButton } from '@reverbdotcom/commons/src/rc/RCCloseButton';

interface IExternalProps {
  entry: Partial<reverb_feed_FeedEntry>;
}

type IProps = ChildMutateProps<IExternalProps, RemoveFeedEntry.Mutation, RemoveFeedEntry.Variables>;

export function HideFeedItem(props: IProps) {
  function removeItem() {
    props.mutate({
      variables: {
        input: {
          entryId: String(props.entry.id),
          entryType: props.entry.type,
        },
      },
    });
  }

  return (
    <RCCloseButton
      onClick={removeItem}
      aria-label={I18n.t('discovery.feed.remove')}
      tooltipText={I18n.t('discovery.feed.removeTooltip')}
    />
  );
}

export default graphql<IExternalProps, RemoveFeedEntry.Mutation, RemoveFeedEntry.Variables>(
  gql`
    mutation RemoveFeedEntry($input: Input_reverb_feed_RemoveEntryRequest) {
      removeFeedEntry(input: $input) {
        entry {
          id
          type
          deleted
        }
      }
    }
  `,
)(HideFeedItem);
